import { render, staticRenderFns } from "./KeyDialogComponent.vue?vue&type=template&id=9b5205b6&scoped=true"
import script from "./KeyDialogComponent.vue?vue&type=script&lang=js"
export * from "./KeyDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5205b6",
  null
  
)

export default component.exports